module.exports = __webpack_public_path__ + "static/media/floatingLabelArrow.07b0f8ea.png";